import React, {ComponentProps} from "react";
import { inject, observer } from "mobx-react";
import { EDIT_DECLARANT } from "../../../../constants/authorize";
import { IAppStore } from "../../../../stores/Interfaces";
import TextArea from "../../columns/textArea";

type Props = {
  value: string;
  store?: IAppStore;
} & Omit<ComponentProps<typeof TextArea>, 'string'>;

const Text: React.FC<Props> = ({ store, value, ...props }: Props) => {
  if (store?.userStore.authorizeByPermission(EDIT_DECLARANT)) {
    return (
      <TextArea string={value} {...props} />
    );
  }

  return <>{value}</>;
};

export default inject("store")(observer(Text));
